import { render, staticRenderFns } from "./DIASParticipantDetail.vue?vue&type=template&id=4a126bb6&"
import script from "./DIASParticipantDetail.vue?vue&type=script&lang=js&"
export * from "./DIASParticipantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports